export const getOnlyNumbers = (v: string) => v.replace(/\D/g, '');
